import { enumCrmAggregateType } from '@rematter/frontend-lib-api-client';
import { Col, Row, Loading, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { LucideBuilding2, LucideUser } from 'lucide-react';

import {
  $remoteCrmOutboxEventCounts,
  useCrmAggregateTypeFilter,
} from '@/audit-log/_state/crmEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

const aggregateTypeConfig = [
  {
    type: enumCrmAggregateType.Account,
    labelKey: 'account' as const,
    icon: LucideBuilding2,
    countKey: 'account' as const,
  },
  {
    type: enumCrmAggregateType.Contact,
    labelKey: 'contact' as const,
    icon: LucideUser,
    countKey: 'contact' as const,
  },
];

export const CrmEventsSidebar = () => {
  const t = useTranslations();
  const [selectedType, setSelectedType] = useCrmAggregateTypeFilter();
  const { data: counts, isLoading } = useAtomValue($remoteCrmOutboxEventCounts);

  const totalCount = counts ? counts.account + counts.contact : 0;

  return (
    <Col className="@CrmEventsSidebar w-[200px] border-r border-neutral/10 p-3">
      <Loading isLoading={isLoading}>
        <Col gap2>
          <button
            onClick={() => setSelectedType(undefined)}
            className={cn(
              'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
              selectedType === undefined
                ? 'bg-primary/10 text-primary'
                : 'hover:bg-neutral/5',
            )}
          >
            <span>{t.crmEventsView.sidebar.all}</span>
            <span className="text-xs text-neutral/50">{totalCount}</span>
          </button>

          {aggregateTypeConfig.map(
            ({ type, labelKey, icon: Icon, countKey }) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={cn(
                  'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
                  selectedType === type
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-neutral/5',
                )}
              >
                <Row gap2 yCenter>
                  <Icon size={16} className="text-neutral/60" />
                  <span>
                    {t.crmEventsView.sidebar.aggregateTypes[labelKey]}
                  </span>
                </Row>
                <span className="text-xs text-neutral/50">
                  {counts?.[countKey] ?? 0}
                </span>
              </button>
            ),
          )}
        </Col>
      </Loading>
    </Col>
  );
};
